import { render, staticRenderFns } from "./AlertasComponent.vue?vue&type=template&id=425fec52&"
import script from "./AlertasComponent.vue?vue&type=script&lang=js&"
export * from "./AlertasComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports